import { normalizeScheduleWindow, schoolToday } from './clientScheduleWindow';

export const PORTAL_SECTIONS = [
  ['dashboard', 'Pulpit'], ['schedule', 'Harmonogram'], ['billing', 'Rozliczenia'], ['packages', 'Pakiety'],
  ['summaries', 'Tematy zajęć'], ['attendance', 'Frekwencja'], ['history', 'Historia'], ['materials', 'Materiały'],
];

export function portalSearch(section, studentId, scheduleWindow) {
  const params = new URLSearchParams();
  if (section !== 'dashboard') params.set('section', section);
  if (studentId) params.set('student', studentId);
  if (scheduleWindow) {
    params.set('from', scheduleWindow.start);
    params.set('days', String(scheduleWindow.days));
  }
  return params.toString() ? `?${params.toString()}` : '';
}

export function parsePortalNavigation(search, students, { today = schoolToday() } = {}) {
  const params = new URLSearchParams(search);
  const section = PORTAL_SECTIONS.some(([id]) => id === params.get('section')) ? params.get('section') : 'dashboard';
  const requested = params.get('student');
  let selectedStudentId = students.some(student => student.id === requested) ? requested : null;
  if (students.length === 1) selectedStudentId = students[0].id;
  const scheduleWindow = section === 'schedule' || params.has('from') || params.has('days')
    ? normalizeScheduleWindow({ start: params.get('from'), days: params.get('days') }, today) : null;
  return { section, selectedStudentId, scheduleWindow, normalizedSearch: portalSearch(section, selectedStudentId, scheduleWindow) };
}
